/*
 * @Author: gaobin
 * @Date: 2025-05-23 11:23:22
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-04 14:07:09
 * @Description: 路由拦截器
 */
import { useLoading } from '@/composables/useGlobalLoading';
import { eventTracker } from '@utils/eventTracker.js';
import { customRP } from './routerLoadTracker';

const { hideLoading } = useLoading();

// 路由跳转方法
const list = ['navigateTo', 'redirectTo', 'reLaunch', 'switchTab', 'navigateBack'];

// #ifdef H5
// 添加H5侧滑返回监听
if (process.env.VUE_APP_PLATFORM === 'h5') {
  window.addEventListener('popstate', function (e) {
    // console.log('回退方式', e);
    if (e.state?.type === 'navigate') {
      console.log('路由返回');
    } else {
      console.log('浏览器后退/手势返回');
      leaveCurPage();
      // 路由切换清空下加载动画
      hideLoading();
    }
  });
}
// #endif

// 用遍历的方式分别为,uni.navigateTo,uni.redirectTo,uni.reLaunch,uni.switchTab这4个路由方法添加拦截器
list.forEach((item) => {
  uni.addInterceptor(item, {
    invoke(e) {
      // showToast({
      //   title: '路由拦截器',
      // });
      // 获取当前页面栈
      const pages = getCurrentPages();

      // 来源路由（离开的路由）
      const fromRoute = pages[pages.length - 1]?.route || '';
      console.log('离开的路由:', fromRoute);

      // 目标路由（跳转的路由)
      let toRoute = '';
      if (item === 'navigateBack') {
        const delta = e.delta || 1;
        // 如果是返回操作，获取上一个页面的路由
        const previousPage = pages[pages.length - delta - 1];
        toRoute = previousPage ? previousPage.route : '';
      } else {
        // 如果不是返回操作，获取跳转的路由
        toRoute = e?.url?.split('?')[0].replace(/^\//, '') || '';
      }
      console.log('跳转的路由:', toRoute);

      // console.log('tracker log=> 路由跳转', e);

      // toRoute 后的参数
      const toQuery = e?.url?.split('?')[1] || '';
      // console.log('tracker log=> 路由跳转的页面信息', toRoute, toQuery);

      // 如果是商品详情页需要存储下商品ID
      const productId = new URLSearchParams(toQuery)?.get('productId');
      // console.log('productId0-----', productId);
      if (productId) {
        uni.setStorageSync('PRODUCT_ID', productId);
      }

      // 跳转进入页面
      if (toRoute) {
        console.log('跳转进入页面 去埋点');
        const params = [
          {
            pageUrl: toRoute,
            action: 'show',
          },
        ];
        eventTracker.addPagePvTracker(params);
      }

      // 检测路由加载速度
      customRP.routeChangeListeners();

      leaveCurPage();

      // 路由切换清空下加载动画
      hideLoading();
    },
    fail(err) {
      // 失败回调拦截
      console.log(err);
    },
  });
});

// 离开当前页面的操作
const leaveCurPage = () => {
  // 在这里添加离开当前页面的操作
  // 在页面跳转前记录离开信息
  const currentPages = getCurrentPages();
  const currentPageUrl = currentPages[currentPages.length - 1]?.route;

  // 改为离开所有页面
  if (currentPageUrl) {
    console.log('离开页面 去埋点', currentPageUrl);
    // 这里可以添加您的埋点逻辑
    const params = [
      {
        pageUrl: currentPageUrl,
        action: 'close',
      },
    ];
    eventTracker.addPagePvTracker(params);
  }
};
